import React, { PureComponent, createRef } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Grid,
  Paper,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Icon,
} from '@material-ui/core'
import { maskAPIKey, toLocalDate } from '../../utils/common'
import { connect } from 'react-redux'
import SearchField from '../common/SearchField'
import { Appcues } from '../../utils/constants'
import { EditableSwitch } from '../../components/common/EditableComponents'
import { UnLinkValue, LinkValue } from '../../assets'

import { searchShopDispatch } from '../../actions/shop'
import {
  updateDCHSettings,
  getDCHSettingsByCompanyId,
  getDCHSettingsByCompanyIdAndShopIds,
} from '../../actions/dispatch'

const style = {
  shopTitle: {
    fontWeight: '590',
    fontSize: '1.1rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    fontWeight: '590',
    display: 'inline-block',
  },
  body: {
    display: 'inline-block',
  },
  bodyv2: {
    display: 'inline-block',
  },
  bodyGreen: {
    fontWeight: '590',
    color: '#41C396',
    display: 'inline-block',
  },
  bodyRed: {
    fontWeight: '590',
    color: '#d32f2f',
    display: 'inline-block',
  },
}

class WmDispatchShopTab extends PureComponent {
  state = {
    term: '',
    checked: false,
    enabledSwitch: false,
    idsFiltered: [],
  }

  addShopModal = createRef()

  componentDidUpdate(prevProps) {
    if (prevProps.shopsList !== this.props.shopsList) {
      this.filterShops('')
    }
  }

  onChangeTerm = (e) => {
    this.setState({ term: e && e.target && e.target.value ? e.target.value : '' })
  }

  onSearch = (value) => {
    if (value == '' || /^( )*$/.test(value)) {
      this.filterShops('')
    } else {
      this.filterShops(value)
    }
  }

  filterShops(value) {
    const { shopsList = [] } = this.props
    let newList = []
    if (value === '') {
      newList = shopsList.map((s) => s.id)
    } else {
      newList = shopsList
        .filter((s) => s.name && s.name.toLowerCase().includes(value.toLowerCase()))
        .map((o) => o.id)
    }
    this.setState({
      idsFiltered: newList,
    })
  }

  handleChange = (e) => {
    this.setState({ checked: e.target.checked })
  }

  setEnabled = (e, setting) => {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id

    if (e && e.target) {
      setting.wmDispatchSettings.enabled = e.target.checked
      this.props
        .dispatch(updateDCHSettings({ request: setting, provider: 'wmDispatch' }))
        .then((res) => {
          Appcues.track('Shops saved')
          this.props.dispatch(getDCHSettingsByCompanyId(companyId))
        })
    }
  }

  goToShop = (shopId) => (e) => {
    this.props.history.push(`/settings/integration/wmDispatch/${shopId}`)
  }

  openAddShop = () => {
    this.props.history.push(`/settings/integration/wmDispatch/add`)
  }

  getName = (shopId) => {
    const { shopsList } = this.props
    const shop = shopsList.filter((element) => {
      return element.id === shopId
    })
    return shop.length > 0 ? shop[0].name : ''
  }

  render() {
    const { shopDispatchList } = this.props
    const { idsFiltered = [] } = this.state

    const shopsFiltered =
      (shopDispatchList && shopDispatchList.filter((sd) => idsFiltered.includes(sd.shopId))) || []
    const classes = style
    return (
      <div style={{ marginTop: '15px' }}>
        <Typography variant="title">My Shops</Typography>
        <Grid container className="margin-top-medium remove-margin">
          <Grid item xs={12} sm={4}>
            <div className="category-rightside">
              <SearchField
                onChange={this.onChangeTerm}
                value={this.state.term}
                onSearch={this.onSearch}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              className="field-check"
              control={<Checkbox checked={this.state.checked} onChange={this.handleChange} />}
              label="Show Shops with Errors"
            />
          </Grid>
          <Grid item xs={12} sm={2} style={{ paddingRight: 3 }}>
            <Button className="bcard" fullWidth onClick={this.openAddShop}>
              <span className="button-text">Add Shop</span>
            </Button>
          </Grid>
        </Grid>
        <Grid container className="full-width">
          <Grid item lg={12} className="margin-top-medium remove-margin">
            {shopsFiltered.length > 0 &&
              shopsFiltered.map((shop, index) => {
                return (
                  (!this.state.checked
                    ? shop.wmDispatchSettings != null
                    : shop.wmDispatchSettings != null &&
                      shop.wmDispatchSettings.linked == false) && (
                    <div key={index} className="main-cards-listing">
                      <Paper
                        className={`center-aligned-child card-inner-list child-column column-child full-width`}
                      >
                        <Typography variant="subheading" style={classes.shopTitle}>
                          {this.getName(shop.shopId)}
                        </Typography>
                        <div className="fragment">
                          <Grid container>
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                              <Typography
                                style={
                                  shop.wmDispatchSettings.linked
                                    ? classes.bodyGreen
                                    : classes.bodyRed
                                }
                              >
                                {' '}
                                {shop.wmDispatchSettings.linked ? 'Linked' : 'Unlinked'}{' '}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={5} md={5} lg={5} className="column-icon-align">
                              <img
                                src={shop.wmDispatchSettings.linked ? LinkValue : UnLinkValue}
                                className="linkedIcon"
                              />
                            </Grid>
                          </Grid>
                          <Grid container>
                            <Grid item xs={12} sm={6} md={6} lg={6} className="column-text-align">
                              <Typography
                                style={
                                  shop.wmDispatchSettings.enabled
                                    ? classes.bodyGreen
                                    : classes.bodyRed
                                }
                              >
                                {' '}
                                {shop.wmDispatchSettings.enabled ? 'Enabled' : 'Disabled'}{' '}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              center
                              xs={12}
                              sm={6}
                              md={6}
                              lg={6}
                              className="column-icon-align"
                            >
                              <EditableSwitch
                                onChange={(event) => this.setEnabled(event, shop)}
                                checked={shop.wmDispatchSettings.enabled || false}
                                valueToRender={shop.wmDispatchSettings.enabled}
                                editMode={true}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        <div className="fragment">
                          <Typography style={classes.subtitle}>
                            {' '}
                            {'WM Dispatch API Key:'}{' '}
                          </Typography>{' '}
                          <div />
                          <Typography style={classes.body}>
                            {' '}
                            {shop.wmDispatchSettings.linked
                              ? maskAPIKey(shop.wmDispatchSettings.apiKey)
                              : '-'}{' '}
                          </Typography>{' '}
                          <div />
                          <Typography style={classes.subtitle}>
                            {' '}
                            {'Last Modified:'}{' '}
                          </Typography>{' '}
                          <div />
                          <Typography style={classes.body}>
                            {' '}
                            {toLocalDate(shop.modified, 'MM/DD/YYYY h:mm a')}{' '}
                          </Typography>
                        </div>
                        <div>
                          <Button className="bcard" fullWidth onClick={this.goToShop(shop.shopId)}>
                            <span className="button-text">View Shop</span>
                          </Button>
                        </div>
                      </Paper>
                    </div>
                  )
                )
              })}
          </Grid>
        </Grid>
      </div>
    )
  }
}

const WmDispatchShopTabConnected = connect(({ shopReducer, integrationReducer, dispatch }) => ({
  shopReducer,
  integrationReducer,
  dispatch,
}))(WmDispatchShopTab)
export default withRouter(WmDispatchShopTabConnected)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchShopTab.js